import type { ImageLightboxItem } from '../components/ImageLightbox'
import { lightboxIndexForImageUrl } from './comicPageLightbox'
import type { ComicPanel } from './comicTypes'

/** 将单格主图与候选图转为灯箱条目（去重，主图在前） */
export function comicPanelToLightboxItems(panel: ComicPanel | null): ImageLightboxItem[] {
  if (!panel) return []
  const items: ImageLightboxItem[] = []
  const seen = new Set<string>()

  const push = (src: string, subtitle: string) => {
    const key = src.trim()
    if (!key || seen.has(key)) return
    seen.add(key)
    items.push({ src: key, subtitle, alt: subtitle })
  }

  if (panel.imageUrl?.trim()) {
    push(panel.imageUrl, '当前定稿')
  }
  panel.candidates.forEach((c, i) => {
    if (c.imageUrl?.trim()) {
      push(c.imageUrl, `候选 ${i + 1}`)
    }
  })
  return items
}

export function lightboxIndexForCandidate(panel: ComicPanel | null, candidateId: string): number {
  const items = comicPanelToLightboxItems(panel)
  const url = panel?.candidates.find((c) => c.id === candidateId)?.imageUrl?.trim()
  if (!url) return 0
  return lightboxIndexForImageUrl(items, url)
}
